/*
      ##    #######   ##     ##  ########   ########   ##    ##   
      ##   ##     ##  ##     ##  ##         ##     ##   ##  ##    
      ##   ##     ##  ##     ##  ##         ##     ##    ####     
      ##   ##     ##  ##     ##  ######     ########      ##      
##    ##   ##  ## ##  ##     ##  ##         ##   ##       ##      
##    ##   ##    ##   ##     ##  ##         ##    ##      ##      
 ######     ##### ##   #######   ########   ##     ##     ##      
*/

// /* GOOGLE MAP */

var $fotorama = null;

jQuery(document).ready(function($) {

	var Map = function() {

		var styles = [{"featureType":"all","elementType":"all","stylers":[{"hue":"#ff0000"},{"saturation":-100},{"lightness":-30}]},{"featureType":"all","elementType":"labels.text.fill","stylers":[{"color":"#ffffff"}]},{"featureType":"all","elementType":"labels.text.stroke","stylers":[{"color":"#353535"}]},{"featureType":"landscape","elementType":"geometry","stylers":[{"color":"#656565"}]},{"featureType":"poi","elementType":"geometry.fill","stylers":[{"color":"#505050"}]},{"featureType":"poi","elementType":"geometry.stroke","stylers":[{"color":"#808080"}]},{"featureType":"road","elementType":"geometry","stylers":[{"color":"#454545"}]}];

		var mapElement = document.getElementById('map');

		var program = {
			lat: jQuery(mapElement).data('lat'),
			lng: jQuery(mapElement).data('lng')
		};

		new google.maps.Map(
			mapElement,
			{
				zoom: 14,
				center: program,
				gestureHandling: 'cooperative',
				mapTypeControl: false,
				streetViewControl: false,
				fullscreenControl: false,
				styles: styles
			}
		);
	};

	var controller = new ScrollMagic.Controller();

	var item = $('.thumb-inner');
	var tween = new TimelineMax();
	tween.add([
		TweenMax.staggerFromTo(item, 0.5, {  x: '100%', opacity: 0}, {  x: '0%', opacity: 1}, 0.15 )
	]);
	var scene = new ScrollMagic.Scene({ 
		duration: 500,
		triggerElement: item.closest('.row'),
		reverse:false
	})
	.triggerHook(0.60)
    .setTween(tween)
    .addTo(controller);

	var item = $('.block');
	var tween = new TimelineMax();
	tween.add([
		TweenMax.staggerFromTo(item, 0.5, {  x: '100%', opacity: 0}, {  x: '0%', opacity: 1}, 0.15 )
	]);
	var scene = new ScrollMagic.Scene({ 
		duration: item.closest('.inner').height(),
		triggerElement: $('.service .row li:eq(4)'),
		reverse:false
	})
    .setTween(tween)
    // .addIndicators()
    .addTo(controller);

    var item = $('.service .box-content [class^="icon-"]');
	var tween = new TimelineMax();
	tween.add([
		TweenMax.staggerFromTo(item, 0.5, {  y: '40px', opacity: 0}, {  y: '0px', opacity: 1}, 0.15 )
	]);
	var scene = new ScrollMagic.Scene({ 
		triggerElement: $('.service'),
		reverse:false
	})
    .setTween(tween)
    .addTo(controller);

    var item_text = $('.box-content h3');
	var tween = new TimelineMax();
	tween.add([
		TweenMax.staggerFromTo(item_text, 0.5, {  y: '-40px', opacity: 0}, {  y: '0px', opacity: 1}, 0.15 )
	]);
	var scene = new ScrollMagic.Scene({ 
		triggerElement: $('.service'),
		reverse:false
	})
    .setTween(tween)
    .addTo(controller);

	$('.owl-carousel').owlCarousel({
	    loop:true,
	    margin:0,
	    nav:false,
	    items:1,
	    autoplay: true,
	    smartSpeed:800,
	    dots:true
	});

	FastClick.attach(document.body);

	$('[data-link]').click(function() {
		window.location.href = $(this).attr('data-link');
	}).find('a').click(function(e) {
		e.stopPropagation();
	});

	/**
	 * Test si les Media Queries sont supportées
	 * Ajoute la classe 'mq' au tag HTML si c'est le cas
	 */
	if ( Modernizr.mq('only all') ) {
		jQuery('html').addClass('mq');
	} else {
		jQuery('html').addClass('no-mq');
	}

	/**
	 * Browser detect : masquage de la bannière
	 */
	$('.browserdetect__close').click(function(e) {
		e.preventDefault();
		$('.browserdetect').addClass('browserdetect--hidden');
	});

	/**
	 * MatchHeight [GRID]
	 */
	$(".harmonize").matchHeight();

	/*
	##     ##  ########   ##    ##   ##     ##  
	###   ###  ##         ###   ##   ##     ##  
	#### ####  ##         ####  ##   ##     ##  
	## ### ##  ######     ## ## ##   ##     ##  
	##     ##  ##         ##  ####   ##     ##  
	##     ##  ##         ##   ###   ##     ##  
	##     ##  ########   ##    ##    #######   
	*/
	$(".toggle-nav").click(function(e){
		e.preventDefault();
		$(this).toggleClass('open');
	});

	$.localScroll({
		target: $('body'), // could be a selector or a jQuery object too.
		queue:true,
		duration:1000,
		hash:true
	});


	/*
	 ######     #######   ##    ##   ########      ###      ######    ########   
	##    ##   ##     ##  ###   ##      ##        ## ##    ##    ##      ##      
	##         ##     ##  ####  ##      ##       ##   ##   ##            ##      
	##         ##     ##  ## ## ##      ##      ##     ##  ##            ##      
	##         ##     ##  ##  ####      ##      #########  ##            ##      
	##    ##   ##     ##  ##   ###      ##      ##     ##  ##    ##      ##      
	 ######     #######   ##    ##      ##      ##     ##   ######       ##      
	*/

	$('input:not([type="submit"]), textarea', '.form').focus(function(){
		$(this).closest('li').addClass('active');
	}).blur(function(){
		if( $(this).val() == "" ) $(this).closest('li').removeClass('active');
	});

	Map();

});
